<div id="wrapper">
    <router-outlet></router-outlet>
    <growl [sticky]="false" [timeOut]="15000"></growl>
</div>
